<template>
  <v-container>
    <v-layout>
      <v-flex>
        <v-data-table
          hide-actions
          :headers="headers"
          :items="merchant"
          :rows-per-page-items="rowPerPage"
          class="merchant-table"
          item-key="name"
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th v-for="header in props.headers" :key="header.value">{{ header.text }}</th>
            </tr>
            <tr class="header-filter">
              <th class="text-xs-left" width="10%"></th>
              <th class="text-xs-left" width="25%"></th>
              <th class="text-xs-left" width="20%">
                <v-select
                  append-icon="expand_more"
                  :items="leadStatus"
                  item-text="text"
                  hide-details
                  solo
                  v-model="filters.leads.value"
                ></v-select>
              </th>
              <th class="text-xs-left" width="25%">
                <v-text-field placehlder="Login" hide-details v-model="filters.login.value"></v-text-field>
              </th>
              <th class="text-xs-left" width="20%">
                <v-select
                  :items="rolesItem"
                  v-model="filters.role.text"
                  placeholder="Role"
                  append-icon="expand_more"
                  color="purple"
                  solo
                  hide-details
                ></v-select>
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <td>{{ props.item.id }}</td>
            <td>{{ props.item.first_name }} {{props.item.last_name}}</td>
            <td>{{ transformLeadsData(props.item.leads) }}</td>
            <td>{{ props.item.login }}</td>
            <td>
              <v-select
                :items="rolesStatus"
                :value="rolesItem[props.item.role]"
                @change="changeUserRole($event, props.item.id)"
                append-icon="expand_more"
                color="purple"
                hide-details
              ></v-select>
            </td>
          </template>
          <template slot="footer">
            <td :colspan="headers.length + 1" class="text-xs-center">
              <v-pagination
                v-model="filters.page.value"
                circle
                color="purple"
                :length="paginationLength"
                :total-visible="10"
              ></v-pagination>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import { addFilters } from "@/utils";

export default {
  name: "merchant_table",

  data: () => ({
    headers: [
      {
        text: "ID",
        value: "id"
      },
      { text: "Name", value: "name" },
      { text: "Leads", value: "leads" },
      { text: "Login", value: "login" },
      { text: "Role", value: "role" }
    ],
    merchant: [],
    rowPerPage: [
      20,
      { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 }
    ],
    filters: {
      page: { value: 1 },
      leads: { text: "All", value: "" },
      login: { value: "" },
      role: { text: "User", value: "0" }
    },
    leadStatus: [
      { text: "Dead leads", value: "0" },
      { text: "Other leads", value: "1" },
      { text: "All", value: "" }
    ],
    rolesStatus: ["User", "Merchant"],
    rolesItem: ["User", "Merchant", "All"],
    paginationLength: 0
  }),

  methods: {
    loadData() {
      let url = this.$hostname + "/admin/users/";
      axios
        .get(addFilters(url, this.filters), {
          headers: {
            Authorization: localStorage.getItem("token")
          }
        })
        .then(response => {
          console.log(response);
          this.merchant = response.data.data;
          this.paginationLength = Math.ceil(
            response.data.count / this.rowPerPage[0]
          );
        });
    },
    changeUserRole(event, userId) {
      let formData = new FormData();
      formData.append("id", +userId);
      formData.append("role", this.rolesItem.indexOf(event));
      axios
        .post(this.$hostname + "/admin/set_role", formData, {
          headers: {
            Authorization: localStorage.getItem("token")
          }
        })
        .then(response => {
          console.log(response);
        });
    },

    transformLeadsData(value) {
      if (value === "null") {
        return "Other Lead";
      } else {
        return this.leadStatus[value].text;
      }
    }
  },

  created() {
    this.loadData();
  },

  computed: {
    role() {
      return this.filters.role.text;
    }
  },

  watch: {
    role() {
      if (this.rolesItem.indexOf(this.role) == 2) {
        this.filters.role.value = "";
      } else {
        this.filters.role.value = this.rolesItem.indexOf(this.role) + "";
      }
    },

    filters: {
      handler() {
        this.loadData();
      },
      deep: true
    }
  }
};
</script>

<style lang="scss">
.merchant-table {
  .v-table {
    thead {
      background-color: #383838;
      th,
      i {
        color: #fff !important;
        font-size: 18px;
      }
      .header-filter {
        background-color: #fff;
        th,
        i {
          color: #000 !important;
        }
      }
    }
    tbody {
      td {
        font-size: 17px;
      }
    }
  }
}
</style>
